import { eventEmitter } from '@magicdoor/solid-use-case-core';
import { createSignal } from 'solid-js';
export function useUseCase(useCaseClass) {
    const [isLoading, setIsLoading] = createSignal(false);
    const [progress, setProgress] = createSignal(0);
    const [didSucceed, setDidSucceed] = createSignal(false);
    const useCase = new useCaseClass(eventEmitter, setProgress);
    const execute = async (params) => {
        try {
            setIsLoading(true);
            setDidSucceed(false);
            await useCase.execute(params);
            setDidSucceed(true);
        }
        catch (error) {
            eventEmitter?.emitError(error);
            setDidSucceed(false);
        }
        finally {
            setIsLoading(false);
        }
    };
    return { execute, isLoading, didSucceed, progress };
}
